module.exports = __webpack_public_path__ + "img/Sammeln.4a127993.svg";